import React from 'react';
import { renderContentFromMetadata } from '@jutro/uiconfig';

import metadata from './ContactUsPageTemplate.metadata.json5';
import { withRouter } from 'react-router-dom';
import {ViewModelForm} from "gw-portals-viewmodel-react";
import {getImageSrc} from '../../../module/nexus-portals-util-js/lobIconUtil'

function ContactUsPageTemplate() {
   
    const overrideProps = {
        contactUsImage:{
            src: getImageSrc("branding/AyrLogo.png")
        }
        
    };

    const renderedContentFromMetadata = renderContentFromMetadata(metadata.pageContent,overrideProps);

    return (
        <ViewModelForm
        uiProps={metadata.pageContent}
        overrideProps={overrideProps}
    />
    );
}

//export default withRouter(ContactUsPageTemplate);
export default ContactUsPageTemplate;
